import React, {Fragment} from 'react';
import {handleCloseModal, register, requestRegister} from '#app/redux/actions/auth'
import {handleTitle} from '#app/redux/actions/interface'
import Form from "./Form";
import {connect} from "react-redux";
import {Container, GreyText, Text, Wrapper} from "./styles";
import {Button, Input, InputContainer} from "finform";
import {Modal} from "src/interface/modal/Modal";
import {Row} from "#app/pages/styles";
import {NotifyManager} from "notify-component";
import {Caption} from "#app/components/Text/Typography";

class Register extends Form {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            form: {
                email: '',
                password: '',
                password_confirmation: '',
                captchaValue: '',
                code: '',
                role: 'client',
                promo_code: '',
                form: 'client'
            },
            formErrors: {},
            code: false,
            submitted: false,
            checked: false
        };
    }

    submitRequestRegisterForm() {
        this.setState({
            submitted: true
        }, () => {
            this.props.requestRegister({
                form: this.state.form,
                success: (response, status, xhr) => {
                    this.setState({
                        code: true,
                        submitted: false
                    });
                },
                error: (xhr) => {
                    this.setState({
                        submitted: false,
                    });
                },
                obj: this
            });
        });
    }

    submitRegisterForm() {
        this.setState({
            submitted: true
        }, () => {
            this.props.register({
                form: this.state.form,
                success: (response, status, xhr) => {
                    Modal.handleClose();

                    var header = xhr.getResponseHeader('Authorization');

                    if (header) {
                        localStorage.setItem('api_token', header);
                        this.props.handleCloseModal();

                        this.setState({
                            form: {
                                email: '',
                                password: '',
                                password_confirmation: '',
                                captchaValue: '',
                                code: '',
                                role: 'client',
                                promo_code: '',
                            },
                            submitted: false
                        }, () => {
                            if (typeof this.props.callback === 'function') {
                                this.props.callback();
                            }
                        });
                    } else {
                        NotifyManager.error('Ошибка авторизации')
                    }
                },
                error: (xhr) => {
                    this.setState({
                        submitted: false,
                    });
                },
                obj: this
            });
        });
    }

    handleEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.submitForm();
        }
    }

    submitForm() {
        if (this.state.form) {
            console.log(this.state.form.email, this.state.form.email.length);

            if (this.state.form.email && this.state.form.email.length > 35) {
                NotifyManager.error(
                    "",
                    "Ошибка валидации: адрес электронной почты слишком длинный (не более 35 символов)"
                );
            } else {
                if (this.state.code) {
                    this.submitRegisterForm();
                } else {
                    this.submitRequestRegisterForm()
                }
            }
        }
    }

    renderForm() {
        if (this.state.code) {
            return this.renderCodeForm();
        } else {
            return this.renderRegisterForm()
        }
    }

    renderCodeForm() {
        return <Wrapper>
            <Container>
                <Fragment>
                    <Text className={`style__break-word`}>
                        {this.props.i18n.auth.codeAdvise} {this.state.form.email}
                    </Text>
                    <Row>
                        <InputContainer error={this.getError('code')}>
                            <Input
                                id='register-code'
                                type="text"
                                value={this.state.form.code}
                                onKeyDown={this.handleEnter.bind(this)}
                                onChange={(value) => {
                                    this.setState((prv) => {
                                        prv.form.code = value;
                                        prv.formErrors.code = {};

                                        return prv;
                                    });
                                }}
                                placeholder={this.props.i18n.auth.code}
                            />
                        </InputContainer>
                    </Row>
                </Fragment>
                <GreyText>{this.props.i18n.auth.issue}</GreyText>
                <Row>
                    <Button wide id={`register-submit`} onClick={() => {
                        this.submitForm()
                    }}>
                        {this.props.i18n.auth.confirm}
                    </Button>
                </Row>
            </Container>
        </Wrapper>
    }

    renderRegisterForm() {
        return <Wrapper>
            <Container>
                <Row>
                    <InputContainer error={this.getError('email')}>
                        <Input
                            id='register-email'
                            type="text"
                            name="email"
                            autoComplete='on'
                            value={this.state.form.email}
                            onKeyDown={this.handleEnter.bind(this)}
                            onChange={(value) => {
                                this.setState((prv) => {
                                    prv.form.email = value;
                                    if (prv.formErrors) {
                                        prv.formErrors.email = {};
                                    }

                                    return prv;
                                });
                            }}
                            placeholder={'Email'}
                        />
                    </InputContainer>
                </Row>
                <Row>
                    <InputContainer error={this.getError('password')}>
                        <Input
                            id='register-password'
                            type="password"
                            name="password"
                            value={this.state.form.password}
                            onKeyDown={this.handleEnter.bind(this)}
                            onChange={(value) => {
                                this.setState((prv) => {
                                    prv.form.password = value;
                                    if (prv.formErrors) {
                                        prv.formErrors.password = {};
                                    }

                                    return prv;
                                });
                            }}
                            placeholder={this.props.i18n.auth.password}
                        />
                    </InputContainer>
                </Row>
                <Row>
                    <InputContainer error={this.getError('password_confirmation')}>
                        <Input
                            id='register-password_confirmation'
                            type="password"
                            name="password_confirmation"
                            value={this.state.form.password_confirmation}
                            onKeyDown={this.handleEnter.bind(this)}
                            onChange={(value) => {
                                this.setState((prv) => {
                                    prv.form.password_confirmation = value;
                                    if (prv.formErrors) {
                                        prv.formErrors.password_confirmation = {};
                                    }

                                    return prv;
                                });
                            }}
                            placeholder={this.props.i18n.auth.passwordRepeat}
                        />
                    </InputContainer>
                </Row>
                <Row>
                    <InputContainer error={this.getError('promo_code')}>
                        <Input
                            id='register-promo_code'
                            type="text"
                            name="promo_code"
                            value={this.state.form.promo_code}
                            onKeyDown={this.handleEnter.bind(this)}
                            onChange={(value) => {
                                this.setState((prv) => {
                                    prv.form.promo_code = value;
                                    if (prv.formErrors) {
                                        prv.formErrors.promo_code = {};
                                    }
                                    return prv;
                                });
                            }}
                            placeholder={this.props.i18n.auth.promoCode}
                        />
                    </InputContainer>
                </Row>
                <Row style={{margin: '10px 0'}}>
                    <Caption white>Регистрируясь на сайте Вы соглашаетесь с <a target="_blank" href="/agreement"
                                                                               style={{color: '#4378FF'}}>Пользовательским
                        соглашением</a> и <a target="_blank" href="/policy" style={{color: '#4378FF'}}>Политикой по
                        обработке персональных данных</a>.</Caption>
                </Row>
                <Row>
                    <Button wide id='register-submit' onClick={() => {
                        this.submitForm();
                    }}>{this.props.i18n.auth.toRegister}</Button>
                </Row>
            </Container>
        </Wrapper>
    }

    render() {
        return this.renderForm();
    }
}

const enhance = connect(
    state => ({
        i18n: state.i18n,
    }),
    {register, requestRegister, handleTitle, handleCloseModal}
)

export default enhance(Register)
